import InsertUploadedPagePanelContainer from './InsertUploadedPagePanelContainer';

export default InsertUploadedPagePanelContainer;